<div><a href="javascript:void(0)" (click)="onLinkClick($event)">Modify PA</a></div>